module.exports = __webpack_public_path__ + "img/Dredd_Slo_mo_scene.8634350f.jpg";